import type { AxiosResponse } from 'axios';
import { getMediaModuleAxiosInstance } from '#client';
import type { RouteParamsRequest } from '#models';
import type { MediaDataObject } from '#models/services';
import { routes } from '#routes';

export type DeleteMediaRequest = {
  id: string;
};

export const deleteMedia = async ({ routeParams: { id } }: RouteParamsRequest<DeleteMediaRequest>) =>
  getMediaModuleAxiosInstance().delete<MediaDataObject, AxiosResponse<MediaDataObject>>(routes.media.delete(id));
